var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.asset.type !== "pack")?_c('img',{staticClass:"object-contain h-full",attrs:{"src":_vm.imageUrl}}):_c('sprite-view',{staticClass:"object-contain h-full",attrs:{"sprite":_vm.dummySprite}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }